import {
  related,
  sourceIds,
} from './abilities__barrage-vs-volatile-anomaly-vs-shield.mdx';

export { sourceIds, related };
export const table = {
  headers: ['比较重点', '玩法方向', '选择前核对'],
  rows: [
    ['Shield', '防御，优先提高容错', '适合初周目希望稳妥推进的玩家'],
    ['Barrage', '直接远程投射攻击', '适合愿意安排主动攻击输入的玩家'],
    ['Volatile Anomaly', '召唤支援', '适合喜欢额外场上支援的玩家'],
  ],
};
export const quickAnswer =
  '第一次通关、希望容错更高时，Shield 是稳妥的默认选择；Barrage 偏直接远程攻击，Volatile Anomaly 适合喜欢召唤型玩法的玩家。这是玩法建议，不是实测排名。';

## 三种能力快速对比

Artist 分组提供三种不同思路。先决定自己希望能力补充输出方式，还是帮助应对压力，再做选择。

## 什么时候选 Barrage？

Barrage 对应投射攻击方向。适合想把远处目标纳入战斗节奏、愿意安排主动攻击输入的玩家。

## 什么时候选 Volatile Anomaly？

Volatile Anomaly 对应召唤方向。若你喜欢让额外的场上支援参与战斗，可以把它作为候选，再观察与其他分组的搭配。

## 什么时候选 Shield？

Shield 提供防御思路。若经常在贴身交锋时受到压力，优先补充防御可能更符合需求。

## 以后还能改吗？

以上是玩法建议，不是伤害测试或评分。先在[配装规划器](/build-planner)记录备选，再根据自己的实际操作选择。游戏内重置请核对 The Gap 的Mural（重置入口）与 Reset Item。
